export default "__VITE_ASSET__D9PY3hZs__"